import React, { Fragment } from "react";
import Navbar from "./Navbar";

import "./header.css";

const Header = () => {
  return (
    <Fragment>
      <Navbar />
    </Fragment>
  );
};

export default Header;
